import { render, staticRenderFns } from "./OpGreaterThanIcon.vue?vue&type=template&id=2356b1be&scoped=true"
import script from "./OpGreaterThanIcon.vue?vue&type=script&lang=js"
export * from "./OpGreaterThanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356b1be",
  null
  
)

export default component.exports